export default "__VITE_ASSET__COSOfcb9__"